module.exports = __webpack_public_path__ + "static/media/Group 8.d59bafef.png";